/**
 * Permission codes from AuthService RBAC (roles API response).
 * Use these constants throughout the app with usePermissions().hasPermission(PERMISSION.X).
 * Values match the "Code" field from the backend; constants use PascalCase with no dots.
 */
export const PERMISSION = {
  User_View: 'User.View',
  User_Approve: 'User.Approve',
  User_AssignRole: 'User.AssignRole',
  Exam_View: 'Exam.View',
  Exam_Create: 'Exam.Create',
  Exam_Update: 'Exam.Update',
  Form_Edit: 'Form.Edit',
  Form_EditIntakeOnly: 'Form.EditIntakeOnly',
  Form_Submit: 'Form.Submit',
  Form_Sign: 'Form.Sign',
  Document_View: 'Document.View',
  Document_Upload: 'Document.Upload',
} as const;

export type PermissionCode = (typeof PERMISSION)[keyof typeof PERMISSION];

/** All known permission code values. */
export const PERMISSION_CODES: readonly PermissionCode[] = Object.freeze(
  Object.values(PERMISSION) as PermissionCode[]
);

/** Check if a string is a known permission code. */
export function isPermissionCode(value: string): value is PermissionCode {
  return (PERMISSION_CODES as readonly string[]).includes(value);
}
